import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '99%',
    borderRadius: 24,
    background: '#FFFFFF',
    paddingBottom: 0,
    marginLeft: 5,
    marginTop: 3
  },
  patientsList: {
    flexGrow: 1,
    overflowY: 'auto',
    scrollbarWidth: 'thin'
  },
  patientItem: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 89,
    alignItems: 'center',
    borderBottom: '1px solid #E9E9E9',
    padding: '0 15px',
    '&:last-child': {
      borderBottom: 'none'
    }
  }
}))

const PatientsListSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid item className={classes.patientsList}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className={classes.patientItem}>
            <Skeleton variant="circle" width={48} height={48} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="text" width="10%" height={20} />
          </div>
        ))}
      </Grid>
    </div>
  )
}

export default PatientsListSkeleton
